"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var BillLined = function BillLined(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7 6.5a.5.5 0 01.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm.5 3.5h4a.5.5 0 000-1h-4a.5.5 0 000 1zm9 5h-9a.5.5 0 000 1h9a.5.5 0 000-1zm0-3h-9a.5.5 0 000 1h9a.5.5 0 000-1zm0 6h-9a.5.5 0 000 1h9a.5.5 0 000-1zM20 3.5v17a1.5 1.5 0 01-1.5 1.5h-13A1.5 1.5 0 014 20.5v-17A1.5 1.5 0 015.5 2h13A1.5 1.5 0 0120 3.5zm-1 0a.5.5 0 00-.5-.5h-13a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h13a.5.5 0 00.5-.5zm-3.2 3.328c-.526-.232-.7-.342-.7-.529a.411.411 0 01.269-.358.6.6 0 01.68.18.5.5 0 00.7-.711A1.742 1.742 0 0016 4.973V4.5a.5.5 0 00-1 0v.514h-.018A1.4 1.4 0 0014.1 6.3c0 .87.749 1.2 1.3 1.444.614.271.8.4.8.7a.577.577 0 01-.356.6 1.177 1.177 0 01-1.193-.269.5.5 0 00-.7.711 2.183 2.183 0 001.052.56v.454a.5.5 0 001 0v-.475a1.63 1.63 0 00.229-.068 1.563 1.563 0 00.968-1.519c0-.991-.843-1.363-1.4-1.61z",
    fill: "currentColor"
  })));
};

var _default = BillLined;
exports["default"] = _default;